module.exports = __webpack_public_path__ + "src/assets/img/ic02.dcdf67b8.svg";